import Vue                       from 'vue'
import VueMeta                   from 'vue-meta'
import VueTheMask                from 'vue-the-mask'
import Storage                   from 'vue-web-storage'
import App                       from './App.vue'
import router                    from './router'
import vuetify                   from './plugins/vuetify'
import { i18n, setI18nLanguage } from './lang/lang'
import DataStorePlugin           from './lib/data/DataStore/Plugin/DataStorePlugin'
import UtilsPlugin               from './lib/utils/plugin'
import EventBus                  from './lib/events/eventBus'
import DataStore                 from './api/datastore/DataStore'
import { API }                   from './api/Api'
import DefaultLayout             from './views/layouts/DefaultLayout'

const initVUE = () => {

  Vue.component('default-layout', DefaultLayout)

  Vue.use(VueTheMask)
  Vue.use(EventBus)
  Vue.use(DataStorePlugin)
  Vue.use(UtilsPlugin)
  Vue.use(Storage, {
    prefix : 'pirelli_',
    drivers: ['session', 'local'],
  })
  Vue.use(VueMeta, {
    keyName                : 'metaInfo',
    attribute              : 'data-vue-meta',
    ssrAttribute           : 'data-vue-meta-server-rendered',
    tagIDKeyName           : 'vmid',
    refreshOnceOnNavigation: true
  })

  window.Vue = new Vue({
    el        : '#app',
    directives: {},
    mixins    : [],
    data () {
      return {}
    },
    beforeMount () {
      setI18nLanguage(process.env.VUE_APP_I18N_LOCALE)
    },
    created () {},
    mounted () {},
    beforeDestroy () {},
    methods   : {},
    i18n,
    router,
    vuetify,
    render    : h => h(App)
  })

  if (process.env.NODE_ENV === 'production') {
    Vue.config.productionTip = false
    Vue.config.devtools = false
    Vue.config.debug = false
    Vue.config.silent = true
  }
}

API.Promotion.Config()
   .then(response => {
     if (response.status === 200 && response.data) {
       DataStore.MaintenanceMode = !response.data.data.promotion
       DataStore.Data.CarBrands = response.data.data.brands
       DataStore.Data.CarModels = response.data.data.cars
     } else {
       DataStore.MaintenanceMode = true
     }
     initVUE()
   })
   .catch(e => {})
   .finally(() => {})
